import { useLanguage } from '@i18n/useLanguage'
import Column from '@app/components/layout/Column'
import { i18n } from '@i18n/index'
import { TextLink } from '@app/components/core/link/TextLink'
import { MegaMenuLinks } from '../blocks/common'
import { MegaMenuMobileItem } from '../blocks/MegaMenuMobileItem'
import {
  faBookOpenReader,
  faGraduationCap,
  faQuoteLeft,
} from '@fortawesome/pro-solid-svg-icons'
import { Style } from 'inlines'

const textLinkStyle: Style = { textDecoration: 'none' }

export const LearnMenu = () => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.nav.megaMenu.learnMenu

  return (
    <Column gap="1rem" style={{ alignSelf: 'stretch', flexGrow: 1 }}>
      <MegaMenuMobileItem
        to={MegaMenuLinks.knowledgeHub}
        icon={faBookOpenReader}
        label={translations.knowledgeHub.label}
        description={translations.knowledgeHub.description}
        backgroundColor="var(--palette-yellow-300)"
      >
        <TextLink
          to={MegaMenuLinks.whoWorksArticle}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.knowledgeHub.links.whatCanIDo}
        </TextLink>
        <TextLink
          to={MegaMenuLinks.whowToMakeAccountArticle}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.knowledgeHub.links.createAccount}
        </TextLink>
        <TextLink
          to={MegaMenuLinks.howtoStartProjectArticle}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.knowledgeHub.links.startInitiative}
        </TextLink>
      </MegaMenuMobileItem>
      <MegaMenuMobileItem
        to={MegaMenuLinks.elearning}
        icon={faGraduationCap}
        label={translations.elearning.label}
        description={translations.elearning.description}
        backgroundColor="var(--palette-pink-200)"
      />
      <MegaMenuMobileItem
        to={MegaMenuLinks.blog}
        icon={faQuoteLeft}
        label={translations.stories.label}
        description={translations.stories.description}
        backgroundColor="var(--palette-blue-100)"
      />
    </Column>
  )
}
